module.exports = __webpack_public_path__ + "img/Weapon_63.2b1216c1.png";